import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DataAdministrationService } from '../../data-administration/services/data-administration-service';
import { ImportEntity } from '../../import/entities/ImportEntity';
import { ImportService } from '../../import/services/import.service'; 
import { TranslationService } from '../../import/services/translation.service'; 

@Component({
  selector: 'app-create-value-mapping',
  templateUrl: './create-value-mapping.component.html',
  styleUrls: ['./create-value-mapping.component.scss']
})
export class CreateValueMappingComponent implements OnInit {
	@Input() entityType: string;
	@Input() importProfileId: string;
	@Input() importEntities;
	importEntity: ImportEntity = new ImportEntity();
	databaseEntities = [];
	importEntityForm = new FormGroup({
		primary_key: new FormControl('', [Validators.required]),
		database_entity: new FormControl()
	});
	buttonLocked: boolean = false;

	constructor(private dataAdministrationService: DataAdministrationService, private importService: ImportService, public activeModal: NgbActiveModal, private toastManager: ToastrService, private translate: TranslateService, public translationService: TranslationService) { }

	ngOnInit() {
		this.importEntity['import_profile'] = this.importProfileId;
		this.dataAdministrationService.loadAllCandidates(this.entityType, null, null).subscribe(databaseEntities => {
			this.databaseEntities = databaseEntities;
		}, err => {
			this.translate.get('data_administration.errors.load_form').subscribe((res: string) => {
				this.toastManager.error(res);
				this.activeModal.close();
			});
		});
	}

	saveEntity() {
		this.buttonLocked = true;
		this.importEntity['primary_key'] = this.importEntityForm.get('primary_key').value;
		this.importEntity['database_entity'] = this.importEntityForm.get('database_entity').value;

		this.importService.createImportEntity(this.importEntity).subscribe(
			response => {
				this.translate.get('import.success.import_entity_create').subscribe((res: string) => {
					this.toastManager.success(res);
				});

				if (this.importEntities) this.importEntities.push(response);
				
				this.activeModal.close();
			}, err => {
				this.translate.get('import.errors.import_entity_create').subscribe((res: string) => {
					this.toastManager.error(res);
				});
				this.buttonLocked = false;
			}
		)
	}

	cancel() {
		this.activeModal.close();
	}
}
